import React, { Component } from 'react'
import { DIST_URL } from '../../../../constants/api';

export default class Mark extends Component {
	render(){

		let zone = this.props.zone

		return(		
			<div className="map-marker">
				<img src={DIST_URL+'/assets/images/maps-mark.png'} alt="LJRamos" /> 	
				<small>{zone}</small>		
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/features/PageNeighborhoods/components/Map/mark.js